import { useMemo } from "react";
import { useTraces } from "./useTraces";

export interface RecentSpanSummary {
  spanCount: number;
  lastActivityAt?: Date;
  lastErrorAt?: Date;
}

export function useRecentSpanSummary(projectId: string, windowMinutes = 15) {
  const { data, isLoading, error } = useTraces(projectId, {
    limit: 100,
    windowMinutes,
    refetchInterval: 10000,
  });

  const summary = useMemo<RecentSpanSummary>(() => {
    if (!data) {
      return { spanCount: 0 };
    }

    const allSpans = data.traces.flatMap((trace) => trace.spans);

    if (allSpans.length === 0) {
      return { spanCount: 0 };
    }

    const sortedByStart = [...allSpans].sort(
      (a, b) => Number(b.startTime) - Number(a.startTime),
    );

    const spanCount = allSpans.length;
    const lastActivityAt = new Date(sortedByStart[0].startTime);

    const lastErrorSpan = sortedByStart.find((span) => span.status === "error");
    const lastErrorAt = lastErrorSpan
      ? new Date(lastErrorSpan.startTime)
      : undefined;

    return { spanCount, lastActivityAt, lastErrorAt };
  }, [data]);

  return {
    summary,
    isLoading,
    error,
  };
}
